import { Button, Flex, Table, Typography } from 'antd';
import React from 'react';

import { PREFIX } from '@app/constants';
import { CopyServiceModal } from '@app/pages/Clients/EditClientService/components/ClientServiceProductUsages/components';
import {
  useClientServiceProductUsages,
  useClientServiceProductUsagesEffects,
} from '@app/pages/Clients/EditClientService/components/ClientServiceProductUsages/hooks';
import '@app/pages/Clients/EditClientService/components/ClientServiceProductUsages/styles/ClientServiceProductUsages.desktop.scss';
import type { ClientServiceProductUsagesProps } from '@app/pages/Clients/EditClientService/components/ClientServiceProductUsages/types';
import { AddProductsModal } from '@app/pages/Warehouses/WarehouseOperations/components/ProductOperation/ui';

const { Paragraph } = Typography;

export const ClientServiceProductUsages: React.FC<
  ClientServiceProductUsagesProps
> = ({ serviceId, serviceName }) => {
  const {
    isFetchingData,
    warehousesData,
    productsData,
    suppliers,
    clientServiceProductUsagesData,
    memoizedServiceId,
  } = useClientServiceProductUsagesEffects({ serviceId });
  const {
    rows,
    columns,
    handleProductModalOpen,
    onAdd,
    isProductModalOpen,
    handleProductModalClose,
    selectedProducts,
    warehousesOptions,
    handleSaveChanges,
    isSaveClientServiceProductUsagesLoading,
    isDeleteClientServiceProductUsagesLoading,
    handleCopyButtonClick,
    isCopyModalOpen,
    setIsCopyModalOpen,
  } = useClientServiceProductUsages({
    warehousesData,
    clientServiceProductUsagesData,
    productsData,
    serviceId,
  });

  return (
    <div className={`${PREFIX}client-service-product-usage`}>
      <Flex vertical gap={16}>
        <Flex justify="space-between">
          <Paragraph>
            {serviceName
              ? `Технологическая карта услуги '${serviceName}'.`
              : 'Добавьте сюда все товары, которые являются расходниками для данной услуги. Укажите сколько единиц данного товара будет списываться за оказание одной услуги (допусти́м формат дроби).'}
          </Paragraph>
          {!serviceId && (
            <Button type="primary" onClick={handleCopyButtonClick}>
              Копировать
            </Button>
          )}
        </Flex>
        <Table
          dataSource={rows}
          columns={columns}
          rowKey="id"
          pagination={false}
          loading={
            isFetchingData ||
            isSaveClientServiceProductUsagesLoading ||
            isDeleteClientServiceProductUsagesLoading
          }
        />

        {!serviceId && (
          <>
            <Button
              type="default"
              onClick={handleProductModalOpen}
              className="action-button"
              loading={
                isFetchingData ||
                isSaveClientServiceProductUsagesLoading ||
                isDeleteClientServiceProductUsagesLoading
              }
            >
              Добавить товар
            </Button>

            <Button
              type="primary"
              className="action-button"
              loading={
                isFetchingData || isSaveClientServiceProductUsagesLoading
              }
              onClick={handleSaveChanges}
            >
              Сохранить
            </Button>
          </>
        )}
      </Flex>

      <AddProductsModal
        isOpen={isProductModalOpen}
        onClose={handleProductModalClose}
        onAdd={onAdd}
        productList={productsData ?? []}
        suppliersOptions={
          suppliers?.map(({ Name, Id }) => ({
            label: Name,
            value: Id,
          })) || []
        }
        warehousesOptions={warehousesOptions}
        selectedProducts={selectedProducts}
      />

      <CopyServiceModal
        isOpen={isCopyModalOpen}
        setIsOpen={setIsCopyModalOpen}
        serviceId={memoizedServiceId}
      />
    </div>
  );
};
